




























import { Notification } from '@/models';
import { Actions, typedStore } from '@/store';
import Vue from 'vue';
import AchievementNotifications from './AchievementNotifications.vue';
import ActivityNotifications from './ActivityNotifications.vue';
import AwardsNotifications from './AwardsNotifications.vue';
import BadgeNotifications from './BadgeNotifications.vue';

export default Vue.extend({
  name: 'Notifications',
  components: {
    AchievementNotifications,
    ActivityNotifications,
    AwardsNotifications,
    BadgeNotifications,
  },
  data() {
    return {
      step: 1,
    };
  },
  computed: {
    hasNotifications(): boolean {
      return typedStore(this).state.notifications.items.length > 0;
    },
    notifications(): Notification[] {
      return typedStore(this).state.notifications.items;
    },
  },
  methods: {
    async dismiss(notifications: Notification[]) {
      const idList = notifications.map(n => n.id);
      await this.$store.dispatch(Actions.notifications.markAsRead, idList);
    },
    goToNextStep() {
      this.step++;
    },
  },
  watch: {
    step() {
      if (this.step > 4) {
        (document.querySelector('body') as HTMLElement).classList.remove('overflow-hidden');
      }
    },
  },
});
